'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresProductFeatures = function () {
    function WinresProductFeatures($scope, $window, $location, productService, localizationService) {
        _classCallCheck(this, WinresProductFeatures);

        this.$scope = $scope;
        this.$window = $window;
        this.$location = $location;
        this.productService = productService;
        this.features = [];
        this.localizationService = localizationService;
    }

    _createClass(WinresProductFeatures, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().DefaultStartDate
            // getContext().DefaultEndDate
            // getSeoState()

            this.data = this.winresReservationContext.getContext();

            this.useSeo = this.winresReservationContext.getSeoState();

            this.terms = {
                destinationCode: null,
                productCode: null,
                startDate: null,
                endDate: null
            };

            // var startDateString = readUrlPart(this.$location, this.useSeo ? 2 : 1);
            var startDateString = this.winresReservationContext.Params.StartDate;
            if (startDateString) {
                this.terms.startDate = new Date(startDateString);
            } else if (this.data.DefaultStartDate) {
                this.terms.startDate = new Date(this.data.DefaultStartDate);
            }

            // var endDateString = readUrlPart(this.$location, this.useSeo ? 3 : 2);
            var endDateString = this.winresReservationContext.Params.EndDate;
            if (endDateString) {
                this.terms.endDate = new Date(endDateString);
            } else if (this.data.DefaultEndDate) {
                this.terms.endDate = new Date(this.data.DefaultEndDate);
            }

            this.$scope.$watch(function () {
                return _this.data.Destination;
            }, function (destination) {
                // console.log("[WPF] the 'destination' is: ", destination);
                if (destination != null) {
                    _this.terms.destinationCode = destination.DestinationCode;
                    // console.log("[WPF] the 'DestinationCode' is: ", destination.DestinationCode);
                    _this.fetchProducts(destination.DestinationCode, _this.winresReservationContext.getUrlParams().ProductCode);
                }
            });
        }
    }, {
        key: 'fetchProducts',
        value: function fetchProducts(destinationCode, productCode) {
            var _this2 = this;

            // console.log("[WPF] [fetchProducts] the inputted destinationCode is: ", destinationCode);

            this.productService.getReservableProduct(destinationCode, productCode, this.localizationService.getLanguage()).then(function (product) {
                // console.log("[WPF] [fetchProducts] got product:", product);
                if (product) {
                    // DisplayFlags
                    var flags = ['onlyDisplay', 'filterAndDisplay', 'ignoreProductType']; // Ignore product type checks.

                    _this2.productService.getProductFeatures(destinationCode, product.DestinationInfo.ProductCode, flags, _this2.localizationService.getLanguage()).then(function (features) {
                        _this2.features = features;
                        _this2.removeTrailingZeroesFromNumbers(_this2.features);
                        // console.log("[WPF] [fetchProducts] got features and filtered them. Visible features: ", this.features);
                    });
                } else {
                    console.warn('[WPF] Failed to load product features, product is', product);
                }
            }).catch(function (error) {
                console.warn("[WPF] [fetchProducts] Failed to load product features. Error: ", error);
            });
        }
    }, {
        key: 'removeTrailingZeroesFromNumbers',
        value: function removeTrailingZeroesFromNumbers(object) {
            for (var i in object) {
                // Replace comma separators so that javascript understands the numbers
                // and check if number
                if (object.Value != null && !isNaN(parseFloat(object[i].Value.replace(/\./g, '').replace(',', '.')))) {
                    // Replace comma separators so that javascript understands the numbers
                    object[i].Value = object[i].Value.replace(/\./g, '').replace(',', '.');
                    // convert to number
                    object[i].Value = parseFloat(object[i].Value);
                }
            }
        }
    }]);

    return WinresProductFeatures;
}();

WinresProductFeatures.$inject = ['$scope', '$window', '$location', 'productService', 'localizationService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils2.getWebcomponentsUrl)($attrs.templateUrl)) : 'winresProductFeatures';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winresProductFeatures', require('./winresProductFeatures.html'));
}]);

_module3.default.component('winresProductFeatures', {
    templateUrl: getTemplate,
    controller: WinresProductFeatures,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {}
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresProductFeatures/winresProductFeatures.js
// module id = 437
// module chunks = 2